import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import customAnalytics from '../../../../util/custom-analytics';
import { useMediaQuery } from 'react-responsive';
import { PRIMARY_COLOR_6 } from '../../../../appearance/Colors';
import { TESTIMONIALS } from '../../../../data/testimonials';

const propTypes = { ...SectionTilesProps.types };
const defaultProps = { ...SectionTilesProps.defaults };

const Testimonial = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    pushLeft,
    ...props
}) => {
    const outerClasses = classNames(
        'testimonial section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'testimonial-inner section-inner',
        bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
        title: 'Loved by people who save things to use later',
        paragraph: 'Real feedback from people who keep ideas, links, tasks, and notes in Luckynote instead of losing them across apps.'
    };

    const testimonials = TESTIMONIALS;

    const generateAvatar = (name) => {
        const initials = name.split(' ').map(n => n[0]).join('').toUpperCase();
        return (
            <div style={{
                width: 44, height: 44, borderRadius: '50%',
                backgroundColor: PRIMARY_COLOR_6, display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                color: 'white', fontSize: '16px', fontWeight: '600', flexShrink: 0
            }}>
                {initials}
            </div>
        );
    };

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const mid = Math.ceil(testimonials.length / 2);
    const testimonialsByLength = [...testimonials].sort((a, b) => b.text.length - a.text.length);

    const mobileScrollContainerStyle = {
        overflowX: 'auto', paddingBottom: '8px',
        marginLeft: '-24px', marginRight: '-24px',
        WebkitOverflowScrolling: 'touch'
    };
    const mobileRowsWrapperStyle = {
        display: 'flex', flexDirection: 'column', gap: '16px',
        width: 'max-content', marginLeft: '24px', marginRight: '24px'
    };
    const mobileRowStyle = { display: 'flex', flexWrap: 'nowrap', gap: '16px', alignItems: 'flex-start' };
    const mobileCardStyle = { flex: '0 0 auto', width: '280px', minWidth: '280px' };

    const cardStyle = {
        background: 'white',
        padding: '20px',
        borderRadius: '16px',
        border: '1px solid rgba(20, 17, 15, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        textDecoration: 'none',
        color: 'inherit',
        ...(isMobile ? mobileCardStyle : {})
    };

    const cardInner = (testimonial) => (
        <>
            {/* Author on top */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {testimonial.avatar ? (
                    <img src={testimonial.avatar} alt={testimonial.author}
                        width={88} height={88}
                        style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                ) : generateAvatar(testimonial.author)}
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: '600', fontSize: '15px', color: '#1a1a1a', lineHeight: 1.3 }}>
                        {testimonial.author}
                    </div>
                    <div style={{ fontSize: '13px', color: '#888', marginTop: '2px' }}>{testimonial.role}</div>
                </div>
            </div>
            {/* Quote text */}
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.65', color: '#444' }}>
                {testimonial.text}
            </p>
        </>
    );

    const renderCard = (testimonial, index) => testimonial.link ? (
        <a key={index} href={testimonial.link} target="_blank" rel="noopener noreferrer"
            style={cardStyle}
            onClick={() => {
                customAnalytics.testimonial_open();
                customAnalytics.landingpage_action({ action: 'Testimonial Open' });
            }}>
            {cardInner(testimonial)}
        </a>
    ) : (
        <div key={index} style={cardStyle}>
            {cardInner(testimonial)}
        </div>
    );

    return (
        <section {...props} className={outerClasses}>
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content" />

                    {isMobile ? (
                        <div style={mobileScrollContainerStyle} className="testimonial-carousel">
                            <div style={mobileRowsWrapperStyle}>
                                <div style={mobileRowStyle}>
                                    {testimonialsByLength.slice(0, mid).map((t, i) => renderCard(t, i))}
                                </div>
                                <div style={mobileRowStyle}>
                                    {testimonialsByLength.slice(mid).map((t, i) => renderCard(t, mid + i))}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div style={{ columns: 3, columnGap: '24px' }}>
                            {testimonials.map((t, i) => (
                                <div key={i} style={{ breakInside: 'avoid', marginBottom: '24px' }}>
                                    {renderCard(t, i)}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

Testimonial.propTypes = propTypes;
Testimonial.defaultProps = defaultProps;

export default Testimonial;
